<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div class="columns column12">
					<h2
						v-if="subtitle"
						:class="[
							'subtitle',
							!subtitle.length && 'no-after',
							!introductionContent.length ? 'column12 align-center' : 'column6',
						]"
					>
						{{ subtitle }}
					</h2>
				</div>
				<div
					class="columns column6 title"
					:class="!introductionContent.length ? 'column12 align-center' : 'column6'"
				>
					<h1>{{ title }}</h1>
				</div>
				<div class="columns column6 content">
					<div v-if="introductionContent.length" v-parse-links v-html="introductionContent" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
		<slot name="bgImage">
			<div />
		</slot>
	</section>
	<section v-if="content.length" class="main-content background-light">
		<div class="row justify-left">
			<div class="columns column7">
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</section>
	<slot />
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	introductionContent: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;

	.align-center h1 {
		margin-left: auto;
		margin-right: auto;
	}

	h2.align-center {
		margin-left: auto;
		margin-right: auto;
		width: fit-content;

		&::before {
			left: 0;
		}

		&::after {
			left: unset;
			right: 0;
		}
	}

	.column6 {
		align-self: flex-start;
	}

	.column6.title {
		position: relative;
	}

	.column6.title::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 16px;
		right: 30px;
		height: 1px;
		background-color: #8d8d8d;
	}

	.column6.content {
		padding-top: 15px;
	}
}

@media (max-width: 920px) {
	.column6.title::after {
		display: none;
	}
}

// @media (max-width: 1200px) {
// 	.row {
// 		.column6 {
// 			padding: 0;
// 		}
// 	}
// }
</style>
